"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var syncInstaller_native_exports = {};
__export(syncInstaller_native_exports, {
  getSyncStateInstaller: () => getSyncStateInstaller
});
module.exports = __toCommonJS(syncInstaller_native_exports);
var import_react_native_worklets = require("react-native-worklets");
var import_react_native = require("react-native");
var import_react_native_worklets2 = require("react-native-worklets");
function getSyncStateInstaller() {
  var module2 = import_react_native.TurboModuleRegistry.get("OneNativeSyncState");
  if (!module2) return null;
  return {
    install: function install() {
      var globals = globalThis;
      globals.__UI_WORKLET_RUNTIME_HOLDER = (0, import_react_native_worklets2.getUIRuntimeHolder)();
      try {
        return module2.install();
      } finally {
        delete globals.__UI_WORKLET_RUNTIME_HOLDER;
      }
    }
  };
}
//# sourceMappingURL=syncInstaller.native.js.map
